interface StoreFlagProps {
  storeId: string;
  className?: string;
}

const StoreFlag = ({ className, storeId }: StoreFlagProps) => {
  return (
    <svg className={className} aria-hidden="true" pointerEvents="none">
      <use href={`/storeFlags.svg#${storeId}`} />
    </svg>
  );
};

export default StoreFlag;
